import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { FingerprintJS } from '@vortx-dtvm/vxfingerprint';
import {
  SaveFingerprintInput,
  SaveFingerprintOutput
} from '../../environments/endpoints/ms-fingerprint-schema';
import { environment } from '../../environments/environment';
import { GraphqlClient } from './graphql/graphqlClient';
import { Store } from '@ngxs/store';

@Injectable()
export class FingerprintService {
  fingerprint$: Observable<String>;

  constructor(
    protected graphqlClient: GraphqlClient,
    protected store: Store,
    protected http: HttpClient,
  ) { }

  saveFingerPrint(fingerprint: string): Observable<SaveFingerprintOutput> {
    const url = environment.msFingerprint;

    const input: SaveFingerprintInput = {
      input: fingerprint
    };
    return this.graphqlClient.post<SaveFingerprintInput, SaveFingerprintOutput>(
      url,
      environment.saveFingerprint,
      input
    );
  }

  async generateFingerprint(): Promise<Observable<string>> {
    const options = {
      excludeMicrosoftSilverlightVersion: false,
      excludeJava: false,
      excludeFontSmoothing: false,
      excludeFlashVersion: false,
      excludeAdvancedProperties: false,
      useProxyRequestUrl: false
    };

    const FP = new FingerprintJS(environment.fingerprintJsKey);
    const pf = await FP.load(options);
    const result = await pf.get();
    return new Observable((observer) => observer.next(JSON.stringify(result)));
  }
}
